export default {
    baseStyle: {
        borderRadius: "5"
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmFkZ2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi9hcGV4LW9ubGluZS9jb21wb25lbnQtbGlicmFyeS90aGVtZS9jb21wb25lbnRzL2JhZGdlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLGVBQWU7SUFDYixTQUFTLEVBQUU7UUFDVCxZQUFZLEVBQUUsR0FBRztLQUNsQjtDQUNGLENBQUEiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCB7XG4gIGJhc2VTdHlsZToge1xuICAgIGJvcmRlclJhZGl1czogXCI1XCJcbiAgfVxufSJdfQ==